import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {EMPTY, Observable, of} from 'rxjs';
import {catchError, exhaustMap, map, withLatestFrom} from 'rxjs/operators';
import {API} from '../../shared/constants/api.constants';
import {ErrorHandlingHttpClient} from '../../shared/services/error-handling-http-client.service';
import {PaymentType} from '../../requests/constants/request-details.constants';
import {PopItemTypeModel} from '../../requests/models/pop-design-request.model';
import {Warehouse} from '../../requests/models/warehouse.model';
import {CodeNameModel} from '../../shared/models/code-name.model';
import {UtilsService} from '../../shared/services/utils.service';
import {
  lazyLoadPaymentTypes,
  loadPaymentTypes,
  loadPaymentTypesFailure,
  loadPaymentTypesSuccess,
  loadFSPaymentTypes,
  loadFSPaymentTypesSuccess,
  loadFSPaymentTypesFailure,
  lazyLoadFSPaymentTypes,
  loadPopChannelTypes,
  loadPopChannelTypesSuccess,
  loadPopChannelTypesFailure,
  lazyLoadPopChannelTypes,
  loadPopProdUsageDurationTypes,
  loadPopProdUsageDurationTypesSuccess,
  loadPopProdUsageDurationTypesFailure,
  lazyLoadPopProdUsageDurationTypes,
  loadDielines,
  loadDielinesSuccess,
  loadDielinesFailure,
  lazyLoadDielines,
  loadDataPinFileTypes,
  loadDataPinFileTypesSuccess,
  loadDataPinFileTypesFailure,
  lazyLoadDataPinFileTypes,
  loadSubstrates,
  loadSubstratesSuccess,
  loadSubstratesFailure,
  lazyLoadSubstrates,
  loadRedemptionTypes,
  loadRedemptionTypesSuccess,
  loadRedemptionTypesFailure,
  lazyLoadRedemptionTypes,
  loadRequestItemTypes,
  loadRequestItemTypesSuccess,
  loadRequestItemTypesFailure,
  lazyLoadRequestItemTypes,
  loadRegions,
  loadRegionsSuccess,
  loadRegionsFailure,
  lazyLoadRegions,
  loadWarehouses,
  loadWarehousesSuccess,
  loadWarehousesFailure,
  lazyLoadWarehouses,
  loadCompanies,
  loadCompaniesSuccess,
  loadCompaniesFailure,
  lazyLoadCompanies,
  loadPartnerGroups,
  loadPartnerGroupsSuccess,
  loadPartnerGroupsFailure,
  lazyLoadPartnerGroups,
  loadDesignLineOfBusiness,
  loadDesignLineOfBusinessSuccess,
  loadDesignLineOfBusinessFailure,
  lazyLoadDesignLineOfBusiness,
  loadArtLocationsTypes,
  loadArtLocationsTypesSuccess,
  loadArtLocationsTypesFailure,
  lazyLoadArtLocationsTypes,
  loadDesignSourceTypes,
  loadDesignSourceTypesSuccess,
  loadDesignSourceTypesFailure,
  lazyLoadDesignSourceTypes,
  loadChannelTypes,
  loadChannelTypesSuccess,
  loadChannelTypesFailure,
  lazyLoadChannelTypes,
  loadInventoryTypes,
  loadInventoryTypesSuccess,
  loadInventoryTypesFailure,
  lazyLoadInventoryTypes,
  loadComponentTypes,
  loadComponentTypesSuccess,
  loadComponentTypesFailure,
  lazyLoadComponentTypes,
  loadPopItemTypes,
  loadPopItemTypesSuccess,
  loadPopItemTypesFailure,
  lazyLoadPopItemTypes,
  loadColorTypes,
  loadColorTypesSuccess,
  loadColorTypesFailure,
  lazyLoadColorTypes,
  loadDimensionTypes,
  loadDimensionTypesSuccess,
  loadDimensionTypesFailure,
  lazyLoadDimensionTypes,
  loadFinancialTypes,
  loadFinancialTypesSuccess,
  loadFinancialTypesFailure,
  lazyLoadFinancialTypes,
  loadPopProdEventTypes,
  loadPopProdEventTypesSuccess,
  loadPopProdEventTypesFailure,
  lazyLoadPopProdEventTypes,
  loadPopProdFundingTypes,
  loadPopProdFundingTypesSuccess,
  loadPopProdFundingTypesFailure,
  lazyLoadPopProdFundingTypes,
  loadPopProdItemTypes,
  loadPopProdItemTypesSuccess,
  loadPopProdItemTypesFailure,
  lazyLoadPopProdItemTypes,
  loadPopProdCuttingTypes,
  loadPopProdCuttingTypesSuccess,
  loadPopProdCuttingTypesFailure,
  lazyLoadPopProdCuttingTypes,
  loadPopProdMaterialTypes,
  loadPopProdMaterialTypesSuccess,
  loadPopProdMaterialTypesFailure,
  lazyLoadPopProdMaterialTypes,
  loadPopProdTapeTypes,
  loadPopProdTapeTypesSuccess,
  loadPopProdTapeTypesFailure,
  lazyLoadPopProdTapeTypes,
  loadPopProdInventoryTypes,
  loadPopProdInventoryTypesSuccess,
  loadPopProdInventoryTypesFailure,
  lazyLoadPopProdInventoryTypes,
  loadPrinters,
  loadPrintersSuccess,
  loadPrintersFailure,
  lazyLoadPrinters,
  loadBifComponentTypes,
  loadBifComponentTypesSuccess,
  loadBifComponentTypesFailure,
  lazyLoadBifComponentTypes,
  loadBifFulfillmentTypes,
  loadBifFulfillmentTypesSuccess,
  loadBifFulfillmentTypesFailure,
  lazyLoadBifFulfillmentTypes,
  loadThirdPartyOrderTypes,
  loadThirdPartyOrderTypesSuccess,
  loadThirdPartyOrderTypesFailure,
  lazyLoadThirdPartyOrderTypes,
  loadThirdPartyDataPinFileTypes,
  loadThirdPartyDataPinFileTypesSuccess,
  loadThirdPartyDataPinFileTypesFailure,
  lazyLoadThirdPartyDataPinFileTypes,
  loadThirdPartyPrintOwnerTypes,
  loadThirdPartyPrintOwnerTypesSuccess,
  loadThirdPartyPrintOwnerTypesFailure,
  lazyLoadThirdPartyPrintOwnerTypes,
  loadIhComponents,
  loadIhComponentsSuccess,
  loadIhComponentsFailure,
  lazyLoadIhComponents,
  loadIhPriorities,
  loadIhPrioritiesSuccess,
  loadIhPrioritiesFailure,
  lazyLoadIhPriorities,
  loadReturnFileTypes,
  loadReturnFileTypesSuccess,
  loadReturnFileTypesFailure,
  lazyLoadReturnFileTypes,
  loadImageFormatTypes,
  loadImageFormatTypesSuccess,
  loadImageFormatTypesFailure,
  lazyLoadImageFormatTypes,
  loadThirdPartyCompanies,
  lazyLoadThirdPartyCompanies,
  loadThirdPartyCompaniesSuccess,
  loadThirdPartyCompaniesFailure,
  loadRequestTypeInventoryTypes,
  loadRequestTypeInventoryTypesSuccess,
  loadRequestTypeInventoryTypesFailure,
  lazyLoadRequestTypeInventoryTypes
} from './refdata.actions';
import {refDataInitialState as refdataInitialState} from './refdata.reducer';
import {
  selectArtLocationTypes,
  selectBifComponentTypes,
  selectBifFulfillmentTypes,
  selectChannelTypes,
  selectColorTypes,
  selectCompanies,
  selectComponentTypes,
  selectDataPinFileTypes,
  selectDesignLineOfBusiness,
  selectDesignSourceTypes,
  selectDielines,
  selectDimensionTypes,
  selectFinancialTypes,
  selectFSPaymentTypes,
  selectIhComponents,
  selectIhPriorities,
  selectImageFormatTypes,
  selectInventoryTypes,
  selectPartnerGroups,
  selectPaymentTypes,
  selectPopChannelTypes,
  selectPopItemTypes,
  selectPopProdCuttingTypes,
  selectPopProdEventTypes,
  selectPopProdFundingTypes,
  selectPopProdInventoryTypes,
  selectPopProdItemTypes,
  selectPopProdMaterialTypes,
  selectPopProdTapeTypes,
  selectPopProdUsageDurationTypes,
  selectPrinters,
  selectRedemptionTypes,
  selectRegions,
  selectRequestItemTypes,
  selectRequestTypeInventoryTypes,
  selectReturnFileTypes,
  selectSubstrates,
  selectThirdPartyCompanies,
  selectThirdPartyDataPinFileTypes,
  selectThirdPartyOrderTypes,
  selectThirdPartyPrintOwnerTypes,
  selectWarehouses
} from './refdata.selectors';

@Injectable()
export class RequestRefDataEffects {
  loadPaymentTypes$: Observable<any>;
  lazyLoadPaymentTypes$: Observable<any>;
  loadFSPaymentTypes$: Observable<any>;
  lazyLoadFSPaymentTypes$: Observable<any>;
  loadDielines$: Observable<any>;
  lazyLoadDielines$: Observable<any>;
  loadDataPinFileTypes$: Observable<any>;
  lazyLoadDataPinFileTypes$: Observable<any>;
  loadSubstrates$: Observable<any>;
  lazyLoadSubstrates$: Observable<any>;
  loadRedemptionTypes$: Observable<any>;
  lazyLoadRedemptionTypes$: Observable<any>;
  loadRequestItemTypes$: Observable<any>;
  lazyLoadRequestItemTypes$: Observable<any>;
  loadRegions$: Observable<any>;
  lazyLoadRegions$: Observable<any>;
  loadWarehouses$: Observable<any>;
  lazyLoadWarehouses$: Observable<any>;
  loadCompanies$: Observable<any>;
  lazyLoadCompanies$: Observable<any>;
  loadPartnerGroups$: Observable<any>;
  lazyLoadPartnerGroups$: Observable<any>;
  loadDesignLineOfBusiness$: Observable<any>;
  lazyLoadDesignLineOfBusiness$: Observable<any>;
  loadArtLocationTypes$: Observable<any>;
  lazyLoadArtLocationTypes$: Observable<any>;
  loadDesignSourceTypes: Observable<any>;
  loadDesignSourceTypes$: Observable<any>;
  lazyLoadDesignSourceTypes$: Observable<any>;
  loadChannelTypes$: Observable<any>;
  lazyLoadChannelTypes$: Observable<any>;
  loadPopChannelTypes$: Observable<any>;
  lazyLoadPopChannelTypes$: Observable<any>;
  loadInventoryTypes$: Observable<any>;
  lazyLoadInventoryTypes$: Observable<any>;
  loadRequestTypeInventoryTypes$: Observable<any>;
  lazyLoadRequestTypeInventoryTypes$: Observable<any>;
  loadComponentTypes$: Observable<any>;
  lazyLoadComponentTypes$: Observable<any>;
  loadPopItemTypes$: Observable<any>;
  lazyLoadPopItemTypes$: Observable<any>;
  loadColorTypes$: Observable<any>;
  lazyLoadColorTypes$: Observable<any>;
  loadDimensionTypes$: Observable<any>;
  lazyLoadDimensionTypes$: Observable<any>;
  loadFinancialTypes$: Observable<any>;
  lazyLoadFinancialTypes$: Observable<any>;
  loadPopProdEventTypes$: Observable<any>;
  lazyLoadPopProdEventTypes$: Observable<any>;
  loadPopProdFundingTypes$: Observable<any>;
  lazyLoadPopProdFundingTypes$: Observable<any>;
  loadPopProdUsageDurationTypes$: Observable<any>;
  lazyLoadPopProdUsageDurationTypes$: Observable<any>;
  loadPopProdItemTypes$: Observable<any>;
  lazyLoadPopProdItemTypes$: Observable<any>;
  loadPopProdCuttingTypes$: Observable<any>;
  lazyLoadPopProdCuttingTypes$: Observable<any>;
  loadPopProdMaterialTypes$: Observable<any>;
  lazyLoadPopProdMaterialTypes$: Observable<any>;
  loadPopProdTapeTypes$: Observable<any>;
  lazyLoadPopProdTapeTypes$: Observable<any>;
  loadPopProdInventoryTypes$: Observable<any>;
  lazyLoadPopProdInventoryTypes$: Observable<any>;
  loadPrinters$: Observable<any>;
  lazyLoadPrinters$: Observable<any>;
  loadBifComponentTypes$: Observable<any>;
  lazyLoadBifComponentTypes$: Observable<any>;
  loadBifFulfillmentTypes$: Observable<any>;
  lazyLoadBifFulfillmentTypes$: Observable<any>;
  loadThirdPartyOrderTypes$: Observable<any>;
  lazyThirdPartyOrderTypes$: Observable<any>;
  loadThirdPartyDataPinFileTypes$: Observable<any>;
  lazyLoadThirdPartyDataPinFileTypes$: Observable<any>;
  loadThirdPartyPrintOwnerTypes$: Observable<any>;
  lazyThirdPartyPrintOwnerTypes$: Observable<any>;
  loadThirdPartyCompanies$: Observable<any>;
  lazyLoadThirdPartyCompanies$: Observable<any>;
  loadIhComponents$: Observable<any>;
  lazyLoadIhComponents$: Observable<any>;
  loadIhPriorities$: Observable<any>;
  lazyLoadIhPriorities$: Observable<any>;
  loadReturnFileTypes$: Observable<any>;
  lazyLoadReturnFileTypes$: Observable<any>;
  loadImageFormatTypes$: Observable<any>;
  lazyLoadImageFormatTypes$: Observable<any>;

  constructor(
    private errorHandlingHttpClient: ErrorHandlingHttpClient,
    private utilsService: UtilsService,
    private actions$: Actions,
    private store: Store
  ) {
    /**
     * PaymentTypes
     */
    this.loadPaymentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPaymentTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<PaymentType[]>(`${API.paymentTypes}`).pipe(
            map(data => loadPaymentTypesSuccess({paymentTypes: data})),
            catchError(() => of(loadPaymentTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPaymentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPaymentTypes),
        withLatestFrom(this.store.select(selectPaymentTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.paymentTypes === storedData) {
            return of(loadPaymentTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Financial Service PaymentTypes
     */
    this.loadFSPaymentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadFSPaymentTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<PaymentType[]>(`${API.fsPaymentTypes}`).pipe(
            map(data => loadFSPaymentTypesSuccess({fsPaymentTypes: data})),
            catchError(() => of(loadFSPaymentTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadFSPaymentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadFSPaymentTypes),
        withLatestFrom(this.store.select(selectFSPaymentTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.fsPaymentTypes === storedData) {
            return of(loadFSPaymentTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Dielines
     */
    this.loadDielines$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadDielines),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.dielines}`).pipe(
            map(data => loadDielinesSuccess({dielines: data})),
            catchError(() => of(loadDielinesFailure()))
          )
        )
      )
    );
    this.lazyLoadDielines$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadDielines),
        withLatestFrom(this.store.select(selectDielines)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.dielines === storedData) {
            return of(loadDielines());
          }
          return EMPTY;
        })
      )
    );
    /**
     * DataPinFileTypes
     */
    this.loadDataPinFileTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadDataPinFileTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.dataPINfileTypes}`).pipe(
            map(data => loadDataPinFileTypesSuccess({dataPinFileTypes: data})),
            catchError(() => of(loadDataPinFileTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadDataPinFileTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadDataPinFileTypes),
        withLatestFrom(this.store.select(selectDataPinFileTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.dataPinFileTypes === storedData) {
            return of(loadDataPinFileTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Substrates
     */
    this.loadSubstrates$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadSubstrates),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.substrates}`).pipe(
            map(data => loadSubstratesSuccess({substrates: data})),
            catchError(() => of(loadSubstratesFailure()))
          )
        )
      )
    );
    this.lazyLoadSubstrates$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadSubstrates),
        withLatestFrom(this.store.select(selectSubstrates)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.substrates === storedData) {
            return of(loadSubstrates());
          }
          return EMPTY;
        })
      )
    );
    /**
     * RedemptionTypes
     */
    this.loadRedemptionTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadRedemptionTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.redemptionTypes}`).pipe(
            map(data => loadRedemptionTypesSuccess({redemptionTypes: data})),
            catchError(() => of(loadRedemptionTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadRedemptionTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadRedemptionTypes),
        withLatestFrom(this.store.select(selectRedemptionTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.redemptionTypes === storedData) {
            return of(loadRedemptionTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * RequestItemTypes
     */
    this.loadRequestItemTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadRequestItemTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.requestItemsTypes}`).pipe(
            map(data => loadRequestItemTypesSuccess({requestItemTypes: data})),
            catchError(() => of(loadRequestItemTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadRequestItemTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadRequestItemTypes),
        withLatestFrom(this.store.select(selectRequestItemTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.requestItemTypes === storedData) {
            return of(loadRequestItemTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Regions
     */
    this.loadRegions$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadRegions),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.regions}`).pipe(
            map(data => loadRegionsSuccess({regions: data})),
            catchError(() => of(loadRegionsFailure()))
          )
        )
      )
    );
    this.lazyLoadRegions$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadRegions),
        withLatestFrom(this.store.select(selectRegions)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.regions === storedData) {
            return of(loadRegions());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Warehouses
     */
    this.loadWarehouses$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadWarehouses),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<Warehouse[]>(`${API.warehouses}`).pipe(
            map(data =>
              loadWarehousesSuccess({
                warehouses: [...data].sort(this.utilsService.sortAZNames)
              })
            ),
            catchError(() => of(loadWarehousesFailure()))
          )
        )
      )
    );
    this.lazyLoadWarehouses$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadWarehouses),
        withLatestFrom(this.store.select(selectWarehouses)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.warehouses === storedData) {
            return of(loadWarehouses());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Companies
     */
    this.loadCompanies$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadCompanies),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.companies}`).pipe(
            map(data => loadCompaniesSuccess({companies: data})),
            catchError(() => of(loadCompaniesFailure()))
          )
        )
      )
    );
    this.lazyLoadCompanies$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadCompanies),
        withLatestFrom(this.store.select(selectCompanies)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.companies === storedData) {
            return of(loadCompanies());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PartnerGroups
     */
    this.loadPartnerGroups$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPartnerGroups),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.lineOfBusinessTypes}`).pipe(
            map(data => loadPartnerGroupsSuccess({partnerGroups: data})),
            catchError(() => of(loadPartnerGroupsFailure()))
          )
        )
      )
    );
    this.lazyLoadPartnerGroups$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPartnerGroups),
        withLatestFrom(this.store.select(selectPartnerGroups)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.partnerGroups === storedData) {
            return of(loadPartnerGroups());
          }
          return EMPTY;
        })
      )
    );
    /**
     * DesignLineOfBusiness
     */
    this.loadDesignLineOfBusiness$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadDesignLineOfBusiness),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.designLineOfBusinessTypes}`).pipe(
            map(data => loadDesignLineOfBusinessSuccess({designLineOfBusiness: data})),
            catchError(() => of(loadDesignLineOfBusinessFailure()))
          )
        )
      )
    );
    this.lazyLoadDesignLineOfBusiness$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadDesignLineOfBusiness),
        withLatestFrom(this.store.select(selectDesignLineOfBusiness)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.designLineOfBusiness === storedData) {
            return of(loadDesignLineOfBusiness());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ArtLocationTypes
     */
    this.loadArtLocationTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadArtLocationsTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.artLocationTypes}`).pipe(
            map(data => loadArtLocationsTypesSuccess({artLocationTypes: data})),
            catchError(() => of(loadArtLocationsTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadArtLocationTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadArtLocationsTypes),
        withLatestFrom(this.store.select(selectArtLocationTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.artLocationTypes === storedData) {
            return of(loadArtLocationsTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * DesignSourceTypes
     */
    this.loadDesignSourceTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadDesignSourceTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.designSourceTypes}`).pipe(
            map(data => loadDesignSourceTypesSuccess({designSourceTypes: data})),
            catchError(() => of(loadDesignSourceTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadDesignSourceTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadDesignSourceTypes),
        withLatestFrom(this.store.select(selectDesignSourceTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.designSourceTypes === storedData) {
            return of(loadDesignSourceTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ChannelTypes
     */
    this.loadChannelTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadChannelTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.chnTypes}`).pipe(
            map(data => loadChannelTypesSuccess({channelTypes: data})),
            catchError(() => of(loadChannelTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadChannelTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadChannelTypes),
        withLatestFrom(this.store.select(selectChannelTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.channelTypes === storedData) {
            return of(loadChannelTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopChannelTypes
     */
    this.loadPopChannelTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopChannelTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.popChannelTypes}`).pipe(
            map(data => loadPopChannelTypesSuccess({popChannelTypes: data})),
            catchError(() => of(loadPopChannelTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopChannelTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopChannelTypes),
        withLatestFrom(this.store.select(selectPopChannelTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popChannelTypes === storedData) {
            return of(loadPopChannelTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * InventoryTypes
     */
    this.loadInventoryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadInventoryTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.inventoryTypes}`).pipe(
            map(data => loadInventoryTypesSuccess({inventoryTypes: data})),
            catchError(() => of(loadInventoryTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadInventoryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadInventoryTypes),
        withLatestFrom(this.store.select(selectInventoryTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.inventoryTypes === storedData) {
            return of(loadInventoryTypes());
          }
          return EMPTY;
        })
      )
    );


  /**
   * RequestTypeInventoryTypes
   */
    this.loadRequestTypeInventoryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadRequestTypeInventoryTypes),
        exhaustMap(action =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.requestTypeInventoryTypes(action.requestType)}`).pipe(
            map(data => loadRequestTypeInventoryTypesSuccess({requestTypeInventoryTypes: data})),
            catchError(() => of(loadRequestTypeInventoryTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadRequestTypeInventoryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadRequestTypeInventoryTypes),
        withLatestFrom(this.store.select(selectRequestTypeInventoryTypes)),
        exhaustMap(([{requestType}, storedData]) => {
          if (refdataInitialState.requestTypeInventoryTypes === storedData) {
            return of(loadRequestTypeInventoryTypes({requestType}));
          }
          return EMPTY;
        })
      )
    );

    /**
     * ComponentTypes
     */
    this.loadComponentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadComponentTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.fsComponentTypes}`).pipe(
            map(data => loadComponentTypesSuccess({componentTypes: data})),
            catchError(() => of(loadComponentTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadComponentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadComponentTypes),
        withLatestFrom(this.store.select(selectComponentTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.componentTypes === storedData) {
            return of(loadComponentTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopItemTypes
     */
    this.loadPopItemTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopItemTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<PopItemTypeModel[]>(API.popItemTypes).pipe(
            map(data => loadPopItemTypesSuccess({ popItemTypes: data })),
            catchError(() => of(loadPopItemTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopItemTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopItemTypes),
        withLatestFrom(this.store.select(selectPopItemTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popItemTypes === storedData) {
            return of(loadPopItemTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ColorTypes
     */
    this.loadColorTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadColorTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.colorTypes).pipe(
            map(data => loadColorTypesSuccess({ colorTypes: data })),
            catchError(() => of(loadColorTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadColorTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadColorTypes),
        withLatestFrom(this.store.select(selectColorTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.colorTypes === storedData) {
            return of(loadColorTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * DimensionTypes
     */
    this.loadDimensionTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadDimensionTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.dimensionTypes).pipe(
            map(data => loadDimensionTypesSuccess({ dimensionTypes: data })),
            catchError(() => of(loadDimensionTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadDimensionTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadDimensionTypes),
        withLatestFrom(this.store.select(selectDimensionTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.dimensionTypes === storedData) {
            return of(loadDimensionTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * FinancialTypes
     */
    this.loadFinancialTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadFinancialTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.financialTypes).pipe(
            map(data => loadFinancialTypesSuccess({ financialTypes: data })),
            catchError(() => of(loadFinancialTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadFinancialTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadFinancialTypes),
        withLatestFrom(this.store.select(selectFinancialTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.financialTypes === storedData) {
            return of(loadFinancialTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopProdEventTypes
     */
    this.loadPopProdEventTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdEventTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppEventTypes).pipe(
            map(data => loadPopProdEventTypesSuccess({ popProdEventTypes: data })),
            catchError(() => of(loadPopProdEventTypesFailure()))
          )
        )
      )
    );

    this.lazyLoadPopProdEventTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdEventTypes),
        withLatestFrom(this.store.select(selectPopProdEventTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popProdEventTypes === storedData) {
            return of(loadPopProdEventTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopProdFundingTypes
     */
    this.loadPopProdFundingTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdFundingTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppFundingTypes).pipe(
            map(data => loadPopProdFundingTypesSuccess({ popProdFundingTypes: data })),
            catchError(() => of(loadPopProdFundingTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopProdFundingTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdFundingTypes),
        withLatestFrom(this.store.select(selectPopProdFundingTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popProdFundingTypes === storedData) {
            return of(loadPopProdFundingTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopProdUsageDurationTypes
     */
    this.loadPopProdUsageDurationTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdFundingTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppUsageDurationTypes).pipe(
            map(data => loadPopProdUsageDurationTypesSuccess({ popUsageDurationTypes: data })),
            catchError(() => of(loadPopProdUsageDurationTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopProdUsageDurationTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdUsageDurationTypes),
        withLatestFrom(this.store.select(selectPopProdUsageDurationTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popUsageDurationTypes === storedData) {
            return of(loadPopProdUsageDurationTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopProdItemTypes
     */
    this.loadPopProdItemTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdItemTypes),
        exhaustMap(() => {
          const params = new HttpParams().append('productionOnlyIncluded', 'true');
          return this.errorHandlingHttpClient.get<PopItemTypeModel[]>(API.popItemTypes, { params }).pipe(
            map(data => loadPopProdItemTypesSuccess({ popProdItemTypes: data })),
            catchError(() => of(loadPopProdItemTypesFailure()))
          );
        })
      )
    );
    this.lazyLoadPopProdItemTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdItemTypes),
        withLatestFrom(this.store.select(selectPopProdItemTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popProdItemTypes === storedData) {
            return of(loadPopProdItemTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * PopProdCuttingTypes
     */
    this.loadPopProdCuttingTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdCuttingTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppCuttingTypes).pipe(
            map(popProdCuttingTypes => loadPopProdCuttingTypesSuccess({ popProdCuttingTypes })),
            catchError(() => of(loadPopProdCuttingTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopProdCuttingTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdCuttingTypes),
        withLatestFrom(this.store.pipe(select(selectPopProdCuttingTypes))),
        exhaustMap(([, storedData]) => (refdataInitialState.popProdCuttingTypes === storedData ? of(loadPopProdCuttingTypes()) : EMPTY))
      )
    );
    /**
     * PopProdMaterialTypes
     */
    this.loadPopProdMaterialTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdMaterialTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppMaterialTypes).pipe(
            map(popProdMaterialTypes => loadPopProdMaterialTypesSuccess({ popProdMaterialTypes })),
            catchError(() => of(loadPopProdMaterialTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopProdMaterialTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdMaterialTypes),
        withLatestFrom(this.store.pipe(select(selectPopProdMaterialTypes))),
        exhaustMap(([, storedData]) => (refdataInitialState.popProdMaterialTypes === storedData ? of(loadPopProdMaterialTypes()) : EMPTY))
      )
    );
    /**
     * PopProdTapeTypes
     */
    this.loadPopProdTapeTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdTapeTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppTapeTypes).pipe(
            map(popProdTapeTypes => loadPopProdTapeTypesSuccess({ popProdTapeTypes })),
            catchError(() => of(loadPopProdTapeTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopProdTapeTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdTapeTypes),
        withLatestFrom(this.store.pipe(select(selectPopProdTapeTypes))),
        exhaustMap(([, storedData]) => (refdataInitialState.popProdTapeTypes === storedData ? of(loadPopProdTapeTypes()) : EMPTY))
      )
    );
    /**
     * PopProdInventoryTypes
     */
    this.loadPopProdInventoryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPopProdInventoryTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ppInventoryTypes).pipe(
            map(data => loadPopProdInventoryTypesSuccess({ popProdInventoryTypes: data })),
            catchError(() => of(loadPopProdInventoryTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadPopProdInventoryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPopProdInventoryTypes),
        withLatestFrom(this.store.select(selectPopProdInventoryTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.popProdInventoryTypes === storedData) {
            return of(loadPopProdInventoryTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * Printers
     */
    this.loadPrinters$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadPrinters),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<any[]>(API.printers).pipe(
            map(data =>
              loadPrintersSuccess({
                printers: [...data].sort(this.utilsService.sortAZNames)
              })
            ),
            catchError(() => of(loadPrintersFailure()))
          )
        )
      )
    );
    this.lazyLoadPrinters$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadPrinters),
        withLatestFrom(this.store.select(selectPrinters)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.printers === storedData) {
            return of(loadPrinters());
          }
          return EMPTY;
        })
      )
    );
    /**
     * BifComponentTypes
     */
    this.loadBifComponentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadBifComponentTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.bifComponentTypes}`).pipe(
            map(data => loadBifComponentTypesSuccess({ bifComponentTypes: data })),
            catchError(() => of(loadBifComponentTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadBifComponentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadBifComponentTypes),
        withLatestFrom(this.store.select(selectBifComponentTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.bifComponentTypes === storedData) {
            return of(loadBifComponentTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * BifFulfillmentTypes
     */
    this.loadBifFulfillmentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadBifFulfillmentTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.bifFulfillmentTypes}`).pipe(
            map(data => loadBifFulfillmentTypesSuccess({ bifFulfillmentTypes: data })),
            catchError(() => of(loadBifFulfillmentTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadBifFulfillmentTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadBifFulfillmentTypes),
        withLatestFrom(this.store.select(selectBifFulfillmentTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.bifFulfillmentTypes === storedData) {
            return of(loadBifFulfillmentTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ThirdPartyOrderTypes
     */
    this.loadThirdPartyOrderTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadThirdPartyOrderTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.thirdPartyOrderTypes}`).pipe(
            map(data => loadThirdPartyOrderTypesSuccess({ thirdPartyOrderTypes: data })),
            catchError(() => of(loadThirdPartyOrderTypesFailure()))
          )
        )
      )
    );
    this.lazyThirdPartyOrderTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadThirdPartyOrderTypes),
        withLatestFrom(this.store.select(selectThirdPartyOrderTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.thirdPartyOrderTypes === storedData) {
            return of(loadThirdPartyOrderTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ThirdPartyDataPinFileTypes
     */
    this.loadThirdPartyDataPinFileTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadThirdPartyDataPinFileTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.thirdPartyDataPinFileTypes}`).pipe(
            map(data => loadThirdPartyDataPinFileTypesSuccess({ thirdPartyDataPinFileTypes: data })),
            catchError(() => of(loadThirdPartyDataPinFileTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadThirdPartyDataPinFileTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadThirdPartyDataPinFileTypes),
        withLatestFrom(this.store.select(selectThirdPartyDataPinFileTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.thirdPartyDataPinFileTypes === storedData) {
            return of(loadThirdPartyDataPinFileTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ThirdPartyPrintOwnerTypes
     */
    this.loadThirdPartyPrintOwnerTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadThirdPartyPrintOwnerTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<Array<CodeNameModel & { internal: boolean }>>(`${API.thirdPartyPrintOwnerTypes}`).pipe(
            map(data => loadThirdPartyPrintOwnerTypesSuccess({ thirdPartyPrintOwnerTypes: data })),
            catchError(() => of(loadThirdPartyPrintOwnerTypesFailure()))
          )
        )
      )
    );
    this.lazyThirdPartyPrintOwnerTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadThirdPartyPrintOwnerTypes),
        withLatestFrom(this.store.select(selectThirdPartyPrintOwnerTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.thirdPartyPrintOwnerTypes === storedData) {
            return of(loadThirdPartyPrintOwnerTypes());
          }
          return EMPTY;
        })
      )
    );

    /**
     * ThirdPartyCompanies
     */
    this.loadThirdPartyCompanies$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadThirdPartyCompanies),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(`${API.thirdPartyCompanies}`).pipe(
            map(data => loadThirdPartyCompaniesSuccess({thirdPartyCompanies: data})),
            catchError(() => of(loadThirdPartyCompaniesFailure()))
          )
        )
      )
    );
    this.lazyLoadThirdPartyCompanies$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadThirdPartyCompanies),
        withLatestFrom(this.store.select(selectThirdPartyCompanies)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.thirdPartyCompanies === storedData) {
            return of(loadThirdPartyCompanies());
          }
          return EMPTY;
        })
      )
    );

    /**
     * IhComponents
     */
    this.loadIhComponents$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadIhComponents),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.ihComponents).pipe(
            map(data => loadIhComponentsSuccess({ ihComponents: data })),
            catchError(() => of(loadIhComponentsFailure()))
          )
        )
      )
    );
    this.lazyLoadIhComponents$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadIhComponents),
        withLatestFrom(this.store.select(selectIhComponents)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.ihComponents === storedData) {
            return of(loadIhComponents());
          }
          return EMPTY;
        })
      )
    );
    /**
     * IhPriorities
     */
    this.loadIhPriorities$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadIhPriorities),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<Array<CodeNameModel & { value: number }>>(API.ihPriorities).pipe(
            map(data => loadIhPrioritiesSuccess({ ihPriorities: data })),
            catchError(() => of(loadIhPrioritiesFailure()))
          )
        )
      )
    );
    this.lazyLoadIhPriorities$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadIhPriorities),
        withLatestFrom(this.store.select(selectIhPriorities)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.ihPriorities === storedData) {
            return of(loadIhPriorities());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ReturnFileTypes
     */
    this.loadReturnFileTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadReturnFileTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.thirdPartyReturnFileTypes).pipe(
            map(data => loadReturnFileTypesSuccess({ returnFileTypes: data })),
            catchError(() => of(loadReturnFileTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadReturnFileTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadReturnFileTypes),
        withLatestFrom(this.store.select(selectReturnFileTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.returnFileTypes === storedData) {
            return of(loadReturnFileTypes());
          }
          return EMPTY;
        })
      )
    );
    /**
     * ImageFormatTypes
     */
    this.loadImageFormatTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadImageFormatTypes),
        exhaustMap(() =>
          this.errorHandlingHttpClient.get<CodeNameModel[]>(API.imageFormatTypes).pipe(
            map(data => loadImageFormatTypesSuccess({ imageFormatTypes: data })),
            catchError(() => of(loadImageFormatTypesFailure()))
          )
        )
      )
    );
    this.lazyLoadImageFormatTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(lazyLoadImageFormatTypes),
        withLatestFrom(this.store.select(selectImageFormatTypes)),
        exhaustMap(([, storedData]) => {
          if (refdataInitialState.imageFormatTypes === storedData) {
            return of(loadImageFormatTypes());
          }
          return EMPTY;
        })
      )
    );
  }
}
